module.exports = __webpack_public_path__ + "static/media/system-avatar.08a05abb.svg";